import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const SuccessFailedAttemptUI = (props: UIProperties<SuccessFailedAttemptUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '800px',
				height: '640px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '100%',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='success-failed-attempt-top'>{props.parameters.title}</p>
				</div>
				<div style={{
					width: '100%',
					height: '570px',
					position: 'absolute',
					top: '70px',
					left: '0',
					border: '3px solid rgb(192, 161, 6)',
					backgroundColor: 'rgb(36, 36, 36)',
				}}>
					<div style={{
						height: '290px',
						overflow: 'auto',
						paddingLeft: '20px',
						paddingTop: '10px',
						pointerEvents: 'all'
					}}>
						<p style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'left',
							position: 'relative',
							top: '13px',
							fontWeight: 'normal'
						}} className="title-font" tabIndex={0}>{props.parameters.text}</p>
					</div>

					{props.parameters.imgUrl ? <div style={{
						pointerEvents: 'none',
						position: 'absolute',
						top: '310px',
						left: '50%',
						width: '150px',
						height: '150px',
						transform: 'translate(-50%, 0%)'
					}}>
						<div style={{
							width: '100%',
							height: '100%',
							border: '3px solid rgb(192, 161, 6)',
							backgroundColor: 'rgb(36, 36, 36)',
							pointerEvents: 'none'
						}}>
							<img style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
								width: '80%'
							}} src={props.parameters.imgUrl}/>
						</div>
					</div> : (null)}
					
					<GeneralButtonWithText parameters= {{
						text: 'Continue',
						top: '480px',
						left: '331px',
						width: '130px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onContinueClicked();
						},
						ariaLbl: 'Continue',
						id: 'success-failed-attempt-bottoms'
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

export interface SuccessFailedAttemptUIConfig extends BaseConfig{
	title: string;
	text: string;
	imgUrl?: string;
	onContinueClicked: () => void;
}

export default SuccessFailedAttemptUI;